import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../../../PatientAdd/patientAdd.module.scss';
import Select from '../../../../../_common/Form/Selects/Select/Select';
import InputField from '../../../../../_common/Form/TextFields/InputField';
import Button from '../../../../../_common/Form/Buttons/Button';
import accountHelpers from '../../../../../../utils/accountHelpers';
import { updatePatientRequest } from '../../../../../../store/actions/patients';
import { insuranceTemplate } from '../../../../../../utils/data/data';

const InsuranceModalContent = ({ onCancel }) => {
  const dispatch = useDispatch();

  const { patient } = useSelector((store) => store.patients);
  const patientData = { ...patient };

  if (patient.Prim) {
    insuranceTemplate.forEach(({ path, backPath }) => {
      patientData[`prim${path}`] = patient.Prim[backPath];
    });
  }

  if (patient.Sec) {
    insuranceTemplate.forEach(({ path, backPath }) => {
      patientData[`sec${path}`] = patient.Sec[backPath];
    });
  }

  delete patientData.createdAt;
  delete patientData.Prim;
  delete patientData.Sec;

  const [patientInfo, setPatientInfo] = useState(patientData);
  const [saveLoading, saveLoadingToggle] = useState(false);

  const changePatient = (path, value) => {
    setPatientInfo((prev) => ({
      ...prev,
      [path]: value,
    }));
  };

  const onSave = async () => {
    saveLoadingToggle(true);

    const data = {
      userId: accountHelpers.getUser().id,
      ...patientInfo,
    };

    try {
      await dispatch(updatePatientRequest(data));

      onCancel();

      toast.success('Insurance successfully updated');
    } catch (e) {
      toast.error('Something went wrong');
      console.warn(e);
    }

    saveLoadingToggle(false);
  };

  return (
    <div className={`${classes.wrapper} ${classes.modal}`}>
      <h2>Edit Insurance</h2>

      <div className={classes.fields_container}>
        <div className={classes.bottom_block}>
          <div className={classes.left_block}>
            <h3>Primary Insurance</h3>

            {insuranceTemplate.map(({
              path, label, type, options,
            }) => (
              <div key={path} className={classes.info_field_wrapper}>
                {type === 'select'
                  ? (
                    <Select
                      label={label}
                      onChange={(option) => changePatient(`prim${path}`, option)}
                      currentOption={patientInfo[`prim${path}`] || ''}
                      options={options}
                      zIndex={30}
                    />
                  )
                  : (
                    <InputField
                      label={label}
                      value={patientInfo[`prim${path}`] || ''}
                      onChange={(value) => changePatient(`prim${path}`, value)}
                    />
                  )}
              </div>
            ))}
          </div>

          <div className={classes.right_block}>
            <h3>Secondary Insurance</h3>

            {insuranceTemplate.map(({
              path, label, type, options,
            }) => (
              <div key={path} className={classes.info_field_wrapper}>
                {type === 'select'
                  ? (
                    <Select
                      label={label}
                      onChange={(option) => changePatient(`sec${path}`, option)}
                      currentOption={patientInfo[`sec${path}`] || ''}
                      options={options}
                      zIndex={30}
                    />
                  )
                  : (
                    <InputField
                      label={label}
                      value={patientInfo[`sec${path}`] || ''}
                      onChange={(value) => changePatient(`sec${path}`, value)}
                    />
                  )}
              </div>
            ))}
          </div>
        </div>

        <div className={classes.btns_wrapper}>
          <Button
            loading={saveLoading}
            title="Update insurance"
            reverseColor
            onClick={onSave}
          />

          <Button
            title="Cancel"
            clearButton
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

InsuranceModalContent.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default InsuranceModalContent;
